
import React from 'react';
import { Separator } from '@/components/ui/separator';
import { useLanguage } from '@/contexts/LanguageContext';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { language } = useLanguage();
  
  return (
    <footer className={`mt-16 pb-6 px-4 ${language === 'ur' ? 'font-urdu rtl' : 'font-english ltr'}`}>
      <div className="container mx-auto">
        <Separator className="mb-6 bg-gradient-to-r from-blue-200 via-indigo-300 to-blue-200 h-0.5" />
        <div className="text-center text-gray-500">
          <div className={`flex flex-wrap justify-center gap-4 mb-4 text-sm ${language === 'ur' ? 'flex-row-reverse' : ''}`}>
            <Link to="/about" className="hover:text-primary transition-colors">
              {language === 'ur' ? 'ہمارے بارے میں' : 'About'}
            </Link>
            <Link to="/faq" className="hover:text-primary transition-colors">
              {language === 'ur' ? 'سوالات' : 'FAQ'}
            </Link>
            <Link to="/legal-guides" className="hover:text-primary transition-colors">
              {language === 'ur' ? 'قانونی رہنما' : 'Legal Guides'}
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              {language === 'ur' ? 'شرائط' : 'Terms'}
            </Link>
            <Link to="/privacy" className="hover:text-primary transition-colors">
              {language === 'ur' ? 'رازداری' : 'Privacy'}
            </Link>
          </div>
          <p className="text-sm">© {new Date().getFullYear()} {language === 'ur' ? 'عدالت بوٹ' : 'Adalat Bot'} - {language === 'ur' ? 'تمام حقوق محفوظ ہیں' : 'All rights reserved'}</p>
          <p className="mt-2 text-sm">
            {language === 'ur' 
              ? 'یہ خدمت صرف معلوماتی مقاصد کے لیے ہے۔ قانونی مشورے کے لیے مناسب پیشہ ور سے رجوع کریں۔' 
              : 'This service is for informational purposes only. Consult a professional for legal advice.'}
          </p>
          <div className="mt-4 flex items-center justify-center text-sm">
            <Mail className="h-4 w-4 mr-2" />
            <a href="mailto:admin@adalaturdubotsahulat.info" className="hover:text-primary transition-colors">
              admin@adalaturdubotsahulat.info
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
